module.exports = __webpack_public_path__ + "static/media/numero.7c17abad.png";